export default errors => {
  const isValid = Object.keys(errors).filter(k => !!errors[k]).length === 0;
  const result = !isValid && errors;
  return { errors: result || {}, valid: !result };
};
